<template>
  <div>
    <b-form-select v-model="timeZone" :options="fieldsTZ" style="margin-bottom:10px"></b-form-select>
  </div>
</template>

<script>
export default {
  data () {
    return {
      timeZone: 'LocalTZ',
      fieldsTZ: [
        {value: 'LocalTZ', text: this.$i18n.t('Local timezone')},
        {value: 'CoreTZ', text: this.$i18n.t('Core timezone')},
        {value: +0, text: 'GMT+0 Greenwich Mean Time (GMT)'},
        {value: +1, text: 'GMT+1 Central European Time (CET)'},
        {value: +2, text: 'GMT+2 Eastern European Time (EET)'},
        {value: +3, text: 'GMT+3 Moscow Time (MSK)'},
        {value: +4, text: 'GMT+4 Armenia Time (AMT)'},
        {value: +5, text: 'GMT+5 Pakistan Standard Time (PKT)'},
        {value: +6, text: 'GMT+6 Omsk Time (OMSK)'},
        {value: +7, text: 'GMT+7 Kranoyask Time (KRAT)'},
        {value: +8, text: 'GMT+8 China Standard Time (CST)'},
        {value: +9, text: 'GMT+9 Japan Standard Time (JST)'},
        {value: +10, text: 'GMT+10 Eastern Australia Standard Time (AEST)'},
        {value: +11, text: 'GMT+11 Sakhalin Time (SAKT)'},
        {value: +12, text: 'GMT+12 New Zealand Standard Time (NZST)'},
        {value: -1, text: 'GMT-1 West Africa Time (WAT)'},
        {value: -2, text: 'GMT-2 Azores Time (AT)'},
        {value: -3, text: 'GMT-3 Argentina Time (ART)'},
        {value: -4, text: 'GMT-4 Atlantic Standard Time (AST)'},
        {value: -5, text: 'GMT-5 Eastern Standard Time (EST)'},
        {value: -6, text: 'GMT-6 Central Standard Time (CST)'},
        {value: -7, text: 'GMT-7 Mountain Standard Time (MST)'},
        {value: -8, text: 'GMT-8 Pacific Standard Time (PST)'},
        {value: -9, text: 'GMT-9 Alaska Standard Time (AKST)'},
        {value: -10, text: 'GMT-10 Hawaii Standard Time (HST)'},
        {value: -11, text: 'GMT-11 Nome Time (NT)'},
        {value: -12, text: 'GMT-12 International Date Line West (IDLW)'}
      ]
    }
  },
  methods: {
    setTZ (timeZone) {
      if (timeZone === 'LocalTZ' || timeZone === 'CoreTZ') {
        this.$store.dispatch('Settings/SET_TIMEZONE_DELTA', {tz: 0, tz_selected: timeZone})
      } else {
        this.$store.dispatch('Settings/SET_TIMEZONE_DELTA', {tz: timeZone, tz_selected: 'CustomTZ'})
      }
    }
  },
  watch: {
    timeZone: function (timeZone) {
      this.$store.dispatch('Login/SET_TIME_ZONE', timeZone)
      this.setTZ(timeZone)
    }
  },
  mounted () {
    this.setTZ(this.timeZone)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/appTimeZone.vue